module.exports = "<div class=\"animated fadeIn h-100\">   <div class=\"layout-column layout-align-center-center h-100\"><div class=\"flex-nogrow average c-amber\">{{ averagePerHour | currency:'USD':true }}</div></div></div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/employees/salaries/salary-average/salary-average.component.pug
// module id = 819
// module chunks = 0